<template>
  <div class="cc-page">
    <div class="cc-bg">
      <!-- 顶部 Logo -->
      <img class="cc-logo" :src="require('./login-img/logo-header.png')" />

      <!-- 主体白色卡片 -->
      <div class="cc-card">
        <!-- 返回首页 -->
        <div class="cc-back" @click="$router.push('/')">
          <img :src="require('./login-img/FigmaDDSSlicePNGcabdd2f009de209dbd020527e67df803.png')" class="cc-back-icon" />
          <span class="cc-back-text">返回首页</span>
        </div>

        <!-- 内容区：左侧菜单 + 竖线 + 右侧信息 -->
        <div class="cc-body">
          <!-- 左侧菜单 -->
          <div class="cc-sidebar">
            <div class="cc-menu-group">
              <span class="cc-menu-title">发布</span>
              <span class="cc-menu-item">文&nbsp;&nbsp;章</span>
              <span class="cc-menu-item">视&nbsp;&nbsp;频</span>
            </div>
            <div class="cc-menu-group" style="margin-top:50px;">
              <span class="cc-menu-title">管理统计</span>
              <span class="cc-menu-item">内容列表</span>
              <span class="cc-menu-item">数据统计</span>
            </div>
            <div class="cc-menu-group" style="margin-top:50px;">
              <span class="cc-menu-title">设置</span>
              <span class="cc-menu-item active">企业中心</span>
              <span class="cc-menu-item">意见反馈</span>
              <span class="cc-menu-item cc-logout-item" @click="showLogoutConfirm = true">退出登录</span>
            </div>
          </div>

          <!-- 竖分隔线 -->
          <div class="cc-divider"></div>

          <!-- 右侧：企业信息区 -->
          <div class="cc-main">
            <!-- 头像 + 名称 + 介绍 -->
            <div class="cc-info-top">
              <!-- 头像 -->
              <div class="cc-avatar-col">
                <div class="cc-avatar">
                  <span class="cc-avatar-text">LOGO</span>
                </div>
              </div>
              <!-- 值 -->
              <div class="cc-value-col">
                <span class="cc-name">中国品牌</span>
                <span class="cc-value-gray" style="margin-top:25px;">请输入公司介绍</span>
              </div>
              <!-- 操作 -->
              <div class="cc-action-col">
                <span class="cc-action-link">修改</span>
                <span class="cc-action-link" style="margin-top:28px;">修改</span>
              </div>
            </div>

            <!-- 注册类型 -->
            <div class="cc-row" style="margin-top:35px;">
              <span class="cc-field-label">注册类型</span>
              <span class="cc-value-gray">媒体</span>
              <span class="cc-action-link cc-row-action">修改</span>
            </div>

            <!-- 中品号ID -->
            <div class="cc-row" style="margin-top:35px;">
              <span class="cc-field-label">中品号ID</span>
              <span class="cc-value-gray">1345</span>
              <span class="cc-action-link cc-row-action">修改</span>
            </div>

            <!-- 账号昵称 -->
            <div class="cc-row" style="margin-top:35px;">
              <span class="cc-field-label">账号昵称</span>
              <span class="cc-value-gray">ChinaBrand</span>
              <span class="cc-action-red cc-row-action">审核未通过</span>
            </div>

            <!-- 账号认证标题 -->
            <div class="cc-section-title" style="margin-top:63px;">账号认证</div>

            <!-- 认证名称 -->
            <div class="cc-row">
              <span class="cc-field-label">认证名称</span>
              <span class="cc-value-gray">中国品牌（修改需要审核）</span>
              <span class="cc-action-red cc-row-action">审核未通过</span>
            </div>

            <!-- 登录信息标题 -->
            <div class="cc-section-title">登录信息</div>

            <!-- 绑定手机 -->
            <div class="cc-row">
              <span class="cc-field-label">绑定手机</span>
              <span class="cc-value-gray">18612548282</span>
              <span class="cc-action-link cc-row-action">修改手机号</span>
            </div>

            <!-- 登录密码 -->
            <div class="cc-row" style="margin-top:35px;">
              <span class="cc-field-label">登录密码</span>
              <span class="cc-value-gray">********</span>
              <span class="cc-action-link cc-row-action">修改密码</span>
            </div>

            <!-- 运营者信息标题 -->
            <div class="cc-section-title">运营者信息</div>

            <!-- 姓名 -->
            <div class="cc-row">
              <span class="cc-field-label">姓名</span>
              <span class="cc-value-gray">赵小编</span>
              <span class="cc-action-link cc-row-action">修改</span>
            </div>

            <!-- 创作领域 -->
            <div class="cc-row" style="margin-top:35px;">
              <span class="cc-field-label">创作领域</span>
              <span class="cc-value-gray">科技、财经</span>
              <span class="cc-action-link cc-row-action">修改</span>
            </div>

            <!-- 所在地 -->
            <div class="cc-row" style="margin-top:34px;">
              <span class="cc-field-label">所在地</span>
              <span class="cc-value-gray">北京市-北京市-朝阳区-北三环东路</span>
              <span class="cc-action-link cc-row-action">修改</span>
            </div>

            <!-- 联系邮箱 -->
            <div class="cc-row" style="margin-top:35px;">
              <span class="cc-field-label">联系邮箱</span>
              <span class="cc-value-gray">renmin@qq.com</span>
              <span class="cc-action-link cc-row-action">修改</span>
            </div>

            <!-- 营业执照 -->
            <div class="cc-row" style="margin-top:35px;">
              <span class="cc-field-label">营业执照</span>
              <div class="cc-upload-box">
                <span class="cc-upload-text">上 传</span>
              </div>
              <span class="cc-action-yellow cc-row-action">审核中</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部版权栏 -->
      <div class="cc-footer">
        <div class="cc-footer-inner">
          <div class="cc-footer-links">
            <span @click="$router.push('/about-us')">关于我们</span>
            <span class="cc-footer-sep">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span @click="$router.push('/ad-service')">广告服务</span>
            <span class="cc-footer-sep">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span @click="$router.push('/copyright')">版权声明</span>
            <span class="cc-footer-sep">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span @click="$router.push('/contact-us')">联系我们</span>
          </div>
          <span class="cc-footer-copy">
            《中国品牌》杂志社、中国品牌网&nbsp;&nbsp;&nbsp;&nbsp;<br />
            Copyright © 2008-2028 cbrand.com.cn All rights reserved 中国品牌网版权所有&nbsp;<br />
            京ICP备 16035947 号
          </span>
        </div>
      </div>
    </div>

    <!-- 退出登录确认弹框 -->
    <div class="logout-mask" v-if="showLogoutConfirm">
      <div class="logout-dialog">
        <div class="logout-dialog-title">退出登录</div>
        <div class="logout-dialog-body">确定要退出登录吗？</div>
        <div class="logout-dialog-footer">
          <button class="logout-btn-cancel" @click="showLogoutConfirm = false">取消</button>
          <button class="logout-btn-confirm" @click="confirmLogout">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCenter',
  data() {
    return {
      showLogoutConfirm: false
    }
  },
  methods: {
    confirmLogout() {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.showLogoutConfirm = false
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
* { box-sizing: border-box; margin: 0; padding: 0; }

.cc-page {
  width: 1400px;
  margin: 0 auto;
  background: #fff;
  min-height: 1161px;
}

.cc-bg {
  width: 1400px;
  min-height: 1161px;
  background: url('./login-img/FigmaDDSSlicePNGa9da2e2723302094c7132a362227dc1f.png') center top / cover no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Logo */
.cc-logo {
  width: 577px;
  margin: 31px 0 0 34px;
  object-fit: contain;
  align-self: flex-start;
}

/* 主卡片 */
.cc-card {
  width: 1400px;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  margin-top: 39px;
  padding-bottom: 76px;
}

/* 返回首页 */
.cc-back {
  display: flex;
  align-items: center;
  padding: 27px 0 0 34px;
  cursor: pointer;
  width: fit-content;
}
.cc-back-icon { width: 27px; height: 24px; margin-top: 5px; }
.cc-back-text {
  color: rgba(136, 136, 136, 0.88);
  font-size: 26px;
  font-family: Microsoft YaHei, sans-serif;
  margin-left: 10px;
}

/* 内容区 */
.cc-body {
  display: flex;
  flex-direction: row;
  margin: 38px 0 0 73px;
  width: 1067px;
}

/* 左侧菜单 */
.cc-sidebar {
  width: 72px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.cc-menu-group {
  display: flex;
  flex-direction: column;
}
.cc-menu-title {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  font-family: Microsoft YaHei, sans-serif;
  line-height: 18px;
}
.cc-menu-item {
  font-size: 16px;
  color: rgba(136, 136, 136, 1);
  font-family: Microsoft YaHei, sans-serif;
  line-height: 16px;
  margin-top: 16px;
  cursor: pointer;
  white-space: nowrap;
}
.cc-menu-item.active {
  color: rgba(229, 1, 19, 1);
}
.cc-menu-item:hover { color: rgba(229, 1, 19, 1); }

/* 竖分隔线 */
.cc-divider {
  width: 1px;
  height: 395px;
  border-left: 1px solid rgba(218, 218, 218, 1);
  margin-left: 93px;
  flex-shrink: 0;
}

/* 右侧主区 */
.cc-main {
  flex: 1;
  margin-left: 98px;
  display: flex;
  flex-direction: column;
}

/* 头像+字段区 */
.cc-info-top {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

/* 头像列 */
.cc-avatar-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 90px;
}
.cc-avatar-col .cc-field-label {
  display: inline-block;
  width: 90px;
}
.cc-avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(245, 250, 255, 1);
  border: 1px solid rgba(228, 242, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.cc-avatar-text {
  color: rgba(178, 178, 178, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
}
.cc-field-label {
  color: rgba(178, 178, 178, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 14px;
  margin-top: 35px;
  white-space: nowrap;
}

/* 值列 */
.cc-value-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 38px;
}
.cc-name {
  font-size: 22px;
  color: rgba(51, 51, 51, 1);
  font-family: Microsoft YaHei, sans-serif;
  line-height: 22px;
  margin-top: 6px;
}
.cc-value-gray {
  color: rgba(178, 178, 178, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 14px;
  white-space: nowrap;
  display: block;
}

/* 操作列 */
.cc-action-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 506px;
}
.cc-action-link {
  color: rgba(204, 204, 204, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 14px;
  cursor: pointer;
  white-space: nowrap;
}
.cc-action-link:hover { color: rgba(229, 1, 19, 1); }
.cc-action-red {
  color: rgba(229, 1, 19, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 14px;
  white-space: nowrap;
}
.cc-action-yellow {
  color: rgba(255, 187, 0, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 14px;
  white-space: nowrap;
}

/* 行布局（账号认证、登录信息、运营者信息、营业执照各行） */
.cc-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 786px;
  margin-top: 11px;
  position: relative;
}
.cc-row .cc-field-label {
  display: inline-block;
  width: 90px;
  margin-top: 0;
}
.cc-row .cc-value-gray,
.cc-row .cc-upload-box {
  margin-left: 38px !important;
}
.cc-row-action {
  position: absolute;
  right: 0;
}

/* 分组标题 */
.cc-section-title {
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 14px;
  margin-top: 63px;
  width: 70px;
}

/* 营业执照上传框 */
.cc-upload-box {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  background: rgba(245, 250, 255, 1);
  border: 1px dashed rgba(200, 220, 240, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.cc-upload-text {
  color: rgba(178, 178, 178, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
}

/* 底部版权栏 */
.cc-footer {
  width: 1400px;
  background: rgba(39, 39, 39, 1);
  margin-top: 105px;
}
.cc-footer-inner {
  width: 523px;
  margin: 0 auto;
  padding: 12px 0 23px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cc-footer-links {
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 34px;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.cc-footer-links span:not(.cc-footer-sep) {
  cursor: pointer;
}
.cc-footer-links span:not(.cc-footer-sep):hover {
  color: rgba(255, 160, 160, 1);
}
.cc-footer-sep {
  color: rgba(255, 255, 255, 1);
}
.cc-footer-copy {
  color: rgba(204, 204, 204, 1);
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 22px;
  margin-top: 5px;
  text-align: center;
}
.cc-logout-item {
  color: rgba(229, 1, 19, 1) !important;
  margin-top: 8px;
}
.cc-logout-item:hover { opacity: 0.75; }

/* 退出确认弹框 */
.logout-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.logout-dialog {
  background: #fff;
  border-radius: 12px;
  padding: 32px 36px 24px;
  width: 320px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
}
.logout-dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
}
.logout-dialog-body {
  font-size: 15px;
  color: #555;
  margin-bottom: 28px;
}
.logout-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.logout-btn-cancel {
  padding: 8px 22px;
  border-radius: 20px;
  border: 1px solid #ddd;
  background: #f5f5f5;
  font-size: 14px;
  cursor: pointer;
  color: #555;
}
.logout-btn-cancel:hover { background: #eee; }
.logout-btn-confirm {
  padding: 8px 22px;
  border-radius: 20px;
  border: none;
  background: rgba(229, 1, 19, 1);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.logout-btn-confirm:hover { opacity: 0.85; }
</style>
